import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { BuilderStoreContext } from "@builder.io/react";
// @ts-expect-error this module is not exported, we imported as a workaround for a bug in builder.io integration
import { tryEval } from "@builder.io/react/dist/lib/src/functions/try-eval";
import { logError } from "@faire/web--source/common/logging";
import { Typography } from "@faire/web--source/slate/Typography";
import parse from "html-react-parser";
import { sanitize } from "isomorphic-dompurify";
import React from "react";
// This is a replicate of the evalExpression function in Builder's native Text component
// https://github.com/BuilderIO/builder/blob/main/packages/react/src/blocks/Text.tsx#L27
var evalExpression = function(expression, state) {
    try {
        return String(expression).replace(/{{([^}]+)}}/g, function(_, group) {
            return tryEval(group, state);
        });
    } catch (error) {
        logError("Builder Typography failed to evaluate expression ".concat(expression, ": ").concat(error));
        return expression;
    }
};
// Split each <p> element into a separate text group
var sanitizeAndGroupText = function(textContent) {
    var sanitizedTextContent = sanitize(textContent.trim());
    return sanitizedTextContent.split("<p>").filter(Boolean).flatMap(function(text) {
        var parts = text.trim().split("</p>");
        var _parts_, _parts_1;
        return [
            (_parts_ = parts[0]) !== null && _parts_ !== void 0 ? _parts_ : "",
            (_parts_1 = parts[1]) !== null && _parts_1 !== void 0 ? _parts_1 : ""
        ].filter(Boolean);
    }).filter(Boolean);
};
var isBreak = function(textGroup) {
    return textGroup === "<br />" || textGroup === "<br/>" || textGroup === "<br>";
};
export var BuilderTypography = function(_param) {
    var textContent = _param.textContent, attributes = _param.attributes, props = _object_without_properties(_param, [
        "textContent",
        "attributes"
    ]);
    var textGroups = sanitizeAndGroupText(textContent);
    return /*#__PURE__*/ _jsx(BuilderStoreContext.Consumer, {
        children: function(state) {
            return textGroups.map(function(textGroup, index) {
                if (isBreak(textGroup)) {
                    return /*#__PURE__*/ _jsx("br", {}, "".concat(attributes.key, "-br-").concat(index));
                }
                return /*#__PURE__*/ _createElement(Typography, _object_spread_props(_object_spread({}, props, attributes), {
                    key: "".concat(attributes.key, "-").concat(index),
                    "builder-id": attributes["builder-id"]
                }), parse(evalExpression(textGroup, state.state)));
            });
        }
    });
};
